// 体育游工具类

// 跟团游订单状态类型
function packageOrderStatusText(status) {
  switch (status) {
    case 1: return '待付款'
    case 2: return '已预付'
    case 4: return '已付款'
    case 9: return '完成'
    case 91: return '退款中'
    case 11: return '已退款'
    default: return ''
  }
}

// 定制游订单状态类型
function customOrderStatusText(status) {
  switch (status) {
    case 1: return '待付款'
    case 2: return '已预付'
    case 4: return '已付款'
    case 9: return '已完成'
    case 91: return '退款中'
    case 11: return '已退款'
    default: return ''
  }
}

// 订单是否已经支付
function orderHadPay(order) {
  let isPay = (order.status === 2 && !order.restPaymentOpen)
  isPay = isPay || (order.status === 4 && order.restPaymentOpen)
  return isPay
}

export {
  packageOrderStatusText,
  customOrderStatusText,
  orderHadPay,
}



// WEBPACK FOOTER //
// ./client/utils/sports-tour-util.js